import React from 'react';
import {useDropzone} from 'react-dropzone';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import {Typography, styled, Stack, Box} from '@mui/material';

const Dropzone = styled('div')({
  border: ' 2px dashed rgb(219, 219, 219)',
  padding: '1rem',
  transition: 'background-color 0.3s',
  cursor: 'pointer',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  '&:hover': {
    backgroundColor: 'rgb(243, 243, 243)',
  },
});

export default function CompanyIconDropzone({
  onDropAccepted,
  onDropRejected,
  previewSrc,
  disabled = false,
  text = 'Drag n Drop the Logo here, or click to select',
}) {
  const [thumbnail, setThumbnail] = React.useState();
  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    accept: 'image/jpg, image/jpeg, image/png',
    maxSize: 1024 * 1024 * 1024, // in bytes
    multiple: false,
    onDropAccepted: files => {
      // console.log('accept', files);
      setThumbnail(URL.createObjectURL(files[0]));

      if (onDropAccepted) {
        onDropAccepted(files[0]);
      }
    },
    onDropRejected: files => {
      setThumbnail(null);
      // console.log('reject', files);
      if (onDropRejected) {
        onDropRejected(files[0].file, files[0].errors);
      }
    },
    disabled,
  });

  React.useEffect(
    () => () => {
      URL.revokeObjectURL(thumbnail);
    },
    [thumbnail]
  );

  React.useEffect(() => {
    if (previewSrc?.file) {
      setThumbnail(URL.createObjectURL(previewSrc?.file));
    }
  }, [previewSrc]);

  return (
    <Stack direction="row" spacing={1}>
      {(thumbnail || previewSrc) && (
        <Box
          sx={{
            border: '1px solid #ddd',
            borderRadius: '4px',
            padding: '4px',
            width: 150,
          }}
          component="img"
          src={thumbnail || previewSrc}
          alt="thumbnail"
        />
      )}
      <Dropzone {...getRootProps()}>
        <input {...getInputProps()} />
        <Typography sx={{mb: 0}} align="center" paragraph>
          <AddAPhotoIcon />
        </Typography>
        {isDragActive ? (
          <Typography align="center" paragraph>
            {text}
          </Typography>
        ) : (
          <Typography align="center" paragraph>
            {text}
          </Typography>
        )}
      </Dropzone>
    </Stack>
  );
}
